var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input_wrap"},[(_vm.status)?_c('span',[_vm._v(_vm._s(_vm.errorMessages))]):_vm._e(),_c('input',{attrs:{"type":"text","placeholder":_vm.placeHoler},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }